module.exports = __webpack_public_path__ + "img/IMG_9181-224_FoamcoreMatted.5f367350.jpg";